import { statuses as phonesOrderStatuses } from '@/constants/phones_constants';

export default {
  data() {
    return {
      useNullablePhonesOrderStatus: true,
    };
  },
  computed: {
    phonesOrderStatusItems() {
      const items = [];
      if (this.useNullablePhonesOrderStatus) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(phonesOrderStatuses)
        .forEach((key) => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.phones_order_statuses.${phonesOrderStatuses[key]}`),
            value: phonesOrderStatuses[key],
          });
        });
      return items;
    },
  },
};
